function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;stroke:#009fe3;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Messages-Chat-Smileys_Conversation_conversation-chat-1",
  transform: "translate(-281.75 -631.75)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_87",
  transform: "translate(282.75 632.75)"
}, /*#__PURE__*/React.createElement("g", {
  id: "conversation-chat-1"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape_347",
  d: "M298.871 690.095a7.123 7.123 0 0 1-7.121-7.121v-35.6a7.123 7.123 0 0 1 7.121-7.121h49.845a7.123 7.123 0 0 1 7.121 7.121v35.6a7.123 7.123 0 0 1-7.121 7.121h-7.121v21.362l-21.362-21.362z",
  className: "cls-1",
  transform: "translate(-249.026 -604.646)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape_348",
  d: "M311.233 689.715l-14.241 14.242v-21.362h-7.121a7.123 7.123 0 0 1-7.121-7.121v-35.6a7.123 7.123 0 0 1 7.121-7.121h49.845a7.123 7.123 0 0 1 7.121 7.121v14.241",
  className: "cls-1",
  transform: "translate(-282.75 -632.75)"
}))));

function SvgConversation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108.811,
    height: 108.811,
    viewBox: "0 0 108.811 108.811",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversation);
export default __webpack_public_path__ + "static/media/conversation.f25e0226.svg";
export { ForwardRef as ReactComponent };